module.exports = __webpack_public_path__ + "img/next.d6c3c351.png";